import { render } from "./ChengePassword.vue?vue&type=template&id=61f666e6"
import script from "./ChengePassword.vue?vue&type=script&lang=js"
export * from "./ChengePassword.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__